'use client'

import { Loader } from './loader'

import { useSettings } from '@/store/settings/context'

export const PageLoading = () => {
  const { settings } = useSettings()

  return (
    <div className="fixed top-0 right-0 bottom-0 left-0 z-990 flex h-full w-full items-center justify-center bg-slate-950 backdrop-blur-xs">
      <Loader logoIcon={settings?.customize?.logo_student_sidebar || null} />
    </div>
  )
}
